import { render, staticRenderFns } from "./companychecksetting.html?vue&type=template&id=a461016e&scoped=true&external"
import script from "./companychecksetting.vue?vue&type=script&lang=js"
export * from "./companychecksetting.vue?vue&type=script&lang=js"
import style0 from "./companychecksetting.vue?vue&type=style&index=0&id=a461016e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a461016e",
  null
  
)

export default component.exports